// Symbole RSVP Please : deux alliances et une étincelle, dans un carré 100 × 100.
// Même dessin côté serveur (server/routes/manifest.ts) et dans l'app
// (mobile/assets, mobile/www/offline.html) : les garder alignés.
export function markShapes(color: string): string {
  return (
    `<circle cx="38" cy="56" r="21" fill="none" stroke="${color}" stroke-width="7"/>` +
    `<circle cx="62" cy="56" r="21" fill="none" stroke="${color}" stroke-width="7"/>` +
    `<path d="M50 14L52.5 21.5L60 24L52.5 26.5L50 34L47.5 26.5L40 24L47.5 21.5Z" fill="${color}"/>`
  );
}

// Favicon : pastille de la couleur donnée, symbole crème au centre (lisible à 16 px).
export function faviconSvg(color: string): string {
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">` +
    `<rect width="100" height="100" rx="22" fill="${color}"/>` +
    `<g transform="translate(9 9) scale(0.82)">${markShapes('#fdfcfb')}</g></svg>`
  );
}
